module.exports = __webpack_public_path__ + "img/supaiweixin_ercode.bd479319.jpg";